import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'GET_MACHINE_DETAILS',
	'UPDATE_UNIT_OWNER_GROUP',
	'UPSERT_MACHINE_DETAILS_ADMIN',
	'UPSERT_MACHINE_DETAILS_COUNTRY_ADMIN',
	'UPSERT_MACHINE_DETAILS_SERVICE_TECHNICIAN_OR_ADMIN',
	'UPSERT_MACHINE_DETAILS_OPTIMIZATION_ACCESS',
	'GET_DROPDOWN_OPTIONS',
	'UPDATE_MACHINE_WEIGHING_SERIAL_NUMBER',

	// Baler functions
	'UPSERT_BALE_STORAGE',

	// Favourite
	'UPDATE_IS_FAVOURITE',

	// Subscription
	'SET_TEMPORARY_SUBSCRIPTION'
);
